export default __webpack_public_path__ + "static/media/whatWeDoImg.8e5e8056.svg";